@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId">{{ label() }}</label>
  <lib-text-input
    [error]="showError"
    [controlId]="inputId"
    [formControl]="inputFormControl()"
    [inputMode]="inputMode()"
    [autocomplete]="autocomplete()"
    [placeholder]="placeholder() ?? ''"
    [helpText]="helpText()">
  </lib-text-input>
  <div class="d-flex align-items-center" [hidden]="!hintText() && !maxCharacters()">
    @if (hintText()) {
      <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
        {{ hintText() }}
      </div>
    }
    @if (maxCharacters() !== null) {
      <div class="ms-auto character-count" [class.character-count-error]="charCount() > (maxCharacters() ?? 0)">
        {{ charCount() | number }}/{{ maxCharacters() | number }}
      </div>
    }
  </div>
  @if (showError && !(inputFormControl().errors?.['no-error-message'] === true)) {
    <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
  }
</div>
